import {
  Companion_getInstance9xluupucl4vq as Companion_getInstance,
  UpdateRestrictionsPartrteren0lopt2 as UpdateRestrictionsPart,
} from './UpdateRestrictions.mjs';
import { NothingSerializer3oixyyf77l4xt as NothingSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../serialization/SerializableProperty.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { DataClassPathPartial2s3bzp98w5uo7 as DataClassPathPartial } from '../serialization/DataClassPath.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Conditionuclxcm24fzd9 as Condition } from './Condition.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareUpdateRestrictionsPartFields() {
  var tmp = Companion_getInstance().b2j(NothingSerializer());
  properties(tmp, prepareUpdateRestrictionsPartFields$lambda);
}
function UpdateRestrictionsPart_path$name$delegate$lambda() {
  return Companion_getInstance().b2j(NothingSerializer()).az().v11(0);
}
function UpdateRestrictionsPart_path$_get_name_$ref_nu5amm() {
  return (p0) => p0.i20();
}
function UpdateRestrictionsPart_path$_get_serializer_$ref_b825vv() {
  return (p0) => p0.h2j();
}
function UpdateRestrictionsPart_path$_get_annotations_$ref_nbe9yf() {
  return (p0) => p0.bz();
}
var UpdateRestrictionsPart_pathClass;
function UpdateRestrictionsPart_path() {
  if (UpdateRestrictionsPart_pathClass === VOID) {
    class $ {
      constructor(t) {
        var tmp = this;
        tmp.y2l_1 = lazy(UpdateRestrictionsPart_path$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z2l_1 = lazy(() => {
          var tmp = Companion_getInstance().b2j(t);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.a2m_1 = lazy(() => Companion_getInstance().b2j(t).az().x11(0));
      }
      i20() {
        var tmp0 = this.y2l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, UpdateRestrictionsPart_path$_get_name_$ref_nu5amm(), null);
        return tmp0.f2();
      }
      b2m(receiver) {
        return receiver.c2m_1;
      }
      k2j(receiver) {
        return this.b2m(receiver instanceof UpdateRestrictionsPart() ? receiver : THROW_CCE());
      }
      f2m(receiver, value) {
        return receiver.g2m(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof UpdateRestrictionsPart() ? receiver : THROW_CCE();
        return this.f2m(tmp, value instanceof DataClassPathPartial() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.z2l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, UpdateRestrictionsPart_path$_get_serializer_$ref_b825vv(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a2m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, UpdateRestrictionsPart_path$_get_annotations_$ref_nbe9yf(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 864774718;
      }
      equals(other) {
        return other instanceof UpdateRestrictionsPart_path();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForClass($, 'UpdateRestrictionsPart_path', VOID, VOID, [SerializableProperty()]);
    UpdateRestrictionsPart_pathClass = $;
  }
  return UpdateRestrictionsPart_pathClass;
}
function UpdateRestrictionsPart_limitedIf$name$delegate$lambda() {
  return Companion_getInstance().b2j(NothingSerializer()).az().v11(1);
}
function UpdateRestrictionsPart_limitedIf$_get_name_$ref_og6lfs() {
  return (p0) => p0.i20();
}
function UpdateRestrictionsPart_limitedIf$_get_serializer_$ref_y9pcy9() {
  return (p0) => p0.h2j();
}
function UpdateRestrictionsPart_limitedIf$_get_annotations_$ref_j7jqnh() {
  return (p0) => p0.bz();
}
var UpdateRestrictionsPart_limitedIfClass;
function UpdateRestrictionsPart_limitedIf() {
  if (UpdateRestrictionsPart_limitedIfClass === VOID) {
    class $ {
      constructor(t) {
        var tmp = this;
        tmp.h2m_1 = lazy(UpdateRestrictionsPart_limitedIf$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i2m_1 = lazy(() => {
          var tmp = Companion_getInstance().b2j(t);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.j2m_1 = lazy(() => Companion_getInstance().b2j(t).az().x11(1));
      }
      i20() {
        var tmp0 = this.h2m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, UpdateRestrictionsPart_limitedIf$_get_name_$ref_og6lfs(), null);
        return tmp0.f2();
      }
      b2m(receiver) {
        return receiver.d2m_1;
      }
      k2j(receiver) {
        return this.b2m(receiver instanceof UpdateRestrictionsPart() ? receiver : THROW_CCE());
      }
      k2m(receiver, value) {
        return receiver.g2m(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof UpdateRestrictionsPart() ? receiver : THROW_CCE();
        return this.k2m(tmp, value instanceof Condition() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.i2m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, UpdateRestrictionsPart_limitedIf$_get_serializer_$ref_y9pcy9(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j2m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, UpdateRestrictionsPart_limitedIf$_get_annotations_$ref_j7jqnh(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -985729972;
      }
      equals(other) {
        return other instanceof UpdateRestrictionsPart_limitedIf();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForClass($, 'UpdateRestrictionsPart_limitedIf', VOID, VOID, [SerializableProperty()]);
    UpdateRestrictionsPart_limitedIfClass = $;
  }
  return UpdateRestrictionsPart_limitedIfClass;
}
function UpdateRestrictionsPart_limitedTo$name$delegate$lambda() {
  return Companion_getInstance().b2j(NothingSerializer()).az().v11(2);
}
function UpdateRestrictionsPart_limitedTo$_get_name_$ref_3oxza2() {
  return (p0) => p0.i20();
}
function UpdateRestrictionsPart_limitedTo$_get_serializer_$ref_se9ovn() {
  return (p0) => p0.h2j();
}
function UpdateRestrictionsPart_limitedTo$_get_annotations_$ref_btap0x() {
  return (p0) => p0.bz();
}
var UpdateRestrictionsPart_limitedToClass;
function UpdateRestrictionsPart_limitedTo() {
  if (UpdateRestrictionsPart_limitedToClass === VOID) {
    class $ {
      constructor(t) {
        var tmp = this;
        tmp.l2m_1 = lazy(UpdateRestrictionsPart_limitedTo$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m2m_1 = lazy(() => {
          var tmp = Companion_getInstance().b2j(t);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.n2m_1 = lazy(() => Companion_getInstance().b2j(t).az().x11(2));
      }
      i20() {
        var tmp0 = this.l2m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, UpdateRestrictionsPart_limitedTo$_get_name_$ref_3oxza2(), null);
        return tmp0.f2();
      }
      b2m(receiver) {
        return receiver.e2m_1;
      }
      k2j(receiver) {
        return this.b2m(receiver instanceof UpdateRestrictionsPart() ? receiver : THROW_CCE());
      }
      k2m(receiver, value) {
        return receiver.g2m(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof UpdateRestrictionsPart() ? receiver : THROW_CCE();
        return this.k2m(tmp, value instanceof Condition() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.m2m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, UpdateRestrictionsPart_limitedTo$_get_serializer_$ref_se9ovn(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n2m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, UpdateRestrictionsPart_limitedTo$_get_annotations_$ref_btap0x(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -985719122;
      }
      equals(other) {
        return other instanceof UpdateRestrictionsPart_limitedTo();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForClass($, 'UpdateRestrictionsPart_limitedTo', VOID, VOID, [SerializableProperty()]);
    UpdateRestrictionsPart_limitedToClass = $;
  }
  return UpdateRestrictionsPart_limitedToClass;
}
function prepareUpdateRestrictionsPartFields$lambda(args) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [new (UpdateRestrictionsPart_path())(args[0]), new (UpdateRestrictionsPart_limitedIf())(args[0]), new (UpdateRestrictionsPart_limitedTo())(args[0])];
}
//region block: exports
export {
  prepareUpdateRestrictionsPartFields as prepareUpdateRestrictionsPartFieldsg3v4fkxma8t1,
};
//endregion

//# sourceMappingURL=UpdateRestrictionsPartFields.mjs.map
